import { useState } from "react";
import {
  GenerateLoadingOrError,
} from "../../lib/utils";
import {
  GeneralContract,
  useListGeneralContracts,
  useListLocations,
  useListMarketZones,
} from "../../lib/api/generalContract";
import { useListTraders } from "../../lib/api/trader";
import { useListCustomers } from "../../lib/api/customer";
import { GeneralContractContent } from "../contracts/components/GeneralContractContent";
import { useSortFilterState } from "../contracts/shared/useGeneralContractState";

export function GeneralContractsDashboard() {
  const sortFilterOptions = useSortFilterState((state: any) => ({
    sorting: state.sorting,
    filters: state.filters,
  }));
  const locationRes = useListLocations();
  const marketZoneRes = useListMarketZones();
  const customersResult = useListCustomers();
  const listTradersRes = useListTraders();

  const contractsRes = useListGeneralContracts(sortFilterOptions);
  const stagedContractsRes = useListGeneralContracts({
    ...sortFilterOptions,
    filters: {
      ...sortFilterOptions.filters,
      staged_for_review: true
    }
  });

  const loadingOrErrorUi = GenerateLoadingOrError([
    locationRes,
    marketZoneRes,
    customersResult,
    contractsRes,
    listTradersRes,
    stagedContractsRes,
  ]);

  if (loadingOrErrorUi) {
    return (
      <section className="flex min-h-full flex-1 flex-col justify-start px-6 py-6 lg:px-8">
        <h1 className="scroll-m-20 text-2xl font-extrabold tracking-tight lg:text-3xl">
          General Contracts
        </h1>
        {loadingOrErrorUi}
      </section>
    );
  }

  const locations = locationRes.data?.data || [];
  const marketZones = marketZoneRes.data?.data || [];
  const customers = customersResult.data?.data || [];
  const contracts = (contractsRes.data?.data || []).slice().sort((a: GeneralContract, b: GeneralContract) => {
    const aHasNo = !a.contract_no;
    const bHasNo = !b.contract_no;
    if (aHasNo !== bHasNo) return aHasNo ? -1 : 1;
    return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
  });
  const stagedContracts = stagedContractsRes.data?.data || [];
  const traders = listTradersRes.data?.data || [];

  return (
    <GeneralContractContent
      showTitle={true}
      contracts={contracts}
      stagedContracts={stagedContracts}
      locations={locations}
      marketZones={marketZones}
      customers={customers}
      traders={traders}
    />
  );
}
